import React from 'react';
import { reduxForm, Field, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import {
  onChangeOutletIds,
  brandsRequest,
  onClickCreateBrand,
  setListBrands,
} from 'actions/library/brand';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import { askConfirmAction } from 'actions/confirm-action';
import { ActionBarWrapper } from 'components/wrappers/pages';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import MenuTitle from 'components/MenuTitle';
import styles from './style.css';

class ActionBar extends React.Component {
  render() {
    const { outlets } = this.props;

    return (
      <div>
        <MenuTitle menuTitle="Brands" />
        <div className="col-sm-4 hidden-xs col-md-6 action-brands">
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this._onClickCreateBrand}
            >
              Create Brands
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="row">
            <div className="col-sm-12 col-xs-12">
              <div className="row">
                <div
                  className={`col-sm-4 col-xs-12 col-md-3 ${
                    styles['btn-outlet']
                  }`}
                >
                  <Field
                    name="outletIds"
                    component={DropdownOutlet}
                    outlets={outlets}
                    onChangeOutletIds={this._onChangeOutletIds}
                  />
                </div>
                <div
                  className={`col-sm-4 col-xs-12 col-md-3 ${
                    styles['btn-search']
                  }`}
                >
                  <Field
                    name="keyword"
                    component={SearchBar}
                    onChange={this._onChangeKeyword}
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onChangeOutletIds = outletIds => {
    const { isDirtyBrand } = this.props;
    if (isDirtyBrand) {
      this.props.dispatch(askConfirmAction(onChangeOutletIds(outletIds)));
    } else {
      this.props.dispatch(onChangeOutletIds(outletIds));
    }
  };

  _onChangeKeyword = (event, keyword) => {
    const { dispatch } = this.props;
    dispatch(setListBrands([]));
    dispatch(showPageLoadingSpinner(true));
    dispatch(brandsRequest({ keyword }));
  };

  _onClickCreateBrand = () => {
    const { isDirtyBrand } = this.props;
    if (isDirtyBrand) {
      this.props.dispatch(askConfirmAction(onClickCreateBrand()));
    } else {
      this.props.dispatch(onClickCreateBrand());
    }
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const { outlets } = state.library.brand;
  const isDirtyBrand = isDirty('brand')(state);
  return {
    outlets,
    isDirtyBrand,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
